export class TimeSheetInfo {
  Month: string
  Year: string
  Weeks: TimeSheetWeekInfo[]
}

export class TimeSheetWeekInfo {
  Days: TimeSheetDayInfo[]
}

export class TimeSheetDayInfo {

  Day: number
  IsToday: boolean
  Event: TimeSheetEventInfo
}

export class TimeSheetEventInfo {
  TimesheetType: number
  TimesheetTypeCode: string
  TimesheetLeaveApplyType: string
}
